<template>
  <div>
    <div class="first_title">{{titleName}}</div>
  </div>
</template>

<script>
export default {
  props: ["titleName"],
  name: "ReportFirstTitle"
};
</script>

<style scoped>
.first_title {
  font-size: 28px;
  color: #0f1824;
  font-weight: bold;
}
</style>
